export const PHONE_DISPLAY = "(720) 329-5714";
export const PHONE_TEL = "tel:+17203295714";
export const ADDRESS = "1399 Kipling St, Lakewood, CO 80215";
export const MAPS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=1399+Kipling+St+Lakewood+CO+80215";
export const GOOGLE_REVIEW_URL =
  "https://www.google.com/maps/search/?api=1&query=Elite+Spa+1399+Kipling+St+Lakewood+CO+80215";

export const IMAGES = {
  heroWater:
    "https://images.unsplash.com/photo-1594289765464-d4d8b4dcf42d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxkYXJrJTIwd2F0ZXIlMjByaXBwbGVzfGVufDB8fHx8MTc4NjIzNjkwN3ww&ixlib=rb-4.1.0&q=85",
  hotStone:
    "https://images.unsplash.com/photo-1696841212541-449ca29397cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxob3QlMjBzdG9uZSUyMG1hc3NhZ2UlMjBzcGF8ZW58MHx8fHwxNzg2MjM2ODkzfDA&ixlib=rb-4.1.0&q=85",
  therapist:
    "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxtYXNzYWdlJTIwdGhlcmFwaXN0fGVufDB8fHx8MTc4NjIzNjg5OHww&ixlib=rb-4.1.0&q=85",
  zenStones:
    "https://static.prod-images.emergentagent.com/jobs/ecec5624-a917-4f22-ad18-cabb450b02ee/images/03f4b44bb180c947ed411db7d9ea376b5ef51ee5978da1747152673ed0ceb983.jpeg",
  footMassage:
    "https://static.prod-images.emergentagent.com/jobs/ecec5624-a917-4f22-ad18-cabb450b02ee/images/93b864920b1df48847477871d1e92744a1d3680ce486cc51e02767d266903eb8.jpeg",
  headMassage:
    "https://static.prod-images.emergentagent.com/jobs/ecec5624-a917-4f22-ad18-cabb450b02ee/images/a04a97dd0427988027e5749621991f2359af9d988935c4ff23f02e696cadc180.jpeg",
  giftCertificate:
    "/spa/gift-certificate.jpg",
  steamRoom:
    "https://images.unsplash.com/photo-1761470575018-135c213340eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxzcGElMjBsdXh1cnl8ZW58MHx8fHwxNzg2MjM2ODk4fDA&ixlib=rb-4.1.0&q=85",
  sauna:
    "https://images.unsplash.com/photo-1739869481946-c054e37a55b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxzdGVhbSUyMHJvb218ZW58MHx8fHwxNzg2MjM2ODk4fDA&ixlib=rb-4.1.0&q=85",
};

export const STANDARD_PRICING = [
  { duration: "30 Minutes", price: "$50" },
  { duration: "45 Minutes", price: "$60" },
  { duration: "60 Minutes", price: "$70" },
  { duration: "75 Minutes", price: "$85" },
  { duration: "90 Minutes", price: "$100" },
  { duration: "120 Minutes", price: "$130" },
];

export const SERVICES = [
  {
    id: "deep-tissue",
    number: "01",
    tag: "Focused Pressure",
    name: "Deep Tissue Massage",
    description:
      "A concentrated massage style using deliberate pressure across areas that feel especially tight or overworked. Pressure preferences can be discussed before the session.",
    suitedFor: "Desk-related tightness, active routines and areas needing focused attention.",
    experience: "Steady, purposeful bodywork with time to focus on priority areas.",
    image: IMAGES.therapist,
    video: "/rituals/v9.mp4",
    pricing: STANDARD_PRICING,
  },
  {
    id: "swedish-hot-stone",
    number: "02",
    tag: "Flowing Warmth",
    name: "Swedish Massage with Hot Stone",
    description:
      "Smooth, flowing massage movements paired with gentle warmth for a slower, deeply calming experience created around relaxation and comfort.",
    suitedFor: "Full-body fatigue, first-time guests and anyone seeking a quiet reset.",
    experience: "Gentle flow, comforting warmth and an unhurried full-body rhythm.",
    image: IMAGES.hotStone,
    video: "/rituals/stone.mp4",
    pricing: STANDARD_PRICING,
  },
  {
    id: "custom",
    number: "03",
    tag: "Feet & Body",
    name: "Custom Massage",
    description:
      "A flexible session customized around your needs on the feet and body. Share the areas you would like prioritized and the pressure level that feels most comfortable.",
    suitedFor: "Guests wanting time divided between the feet, body and selected priority areas.",
    experience: "A personalized balance shaped around comfort and the time available.",
    image: IMAGES.steamRoom,
    video: "/rituals/custom.mp4",
    pricing: STANDARD_PRICING,
  },
  {
    id: "foot",
    number: "04",
    tag: "Reflexology & Renewal",
    name: "Foot Massage",
    description:
      "Foot reflexology-inspired attention for feet that feel tired after long days, travel or extended time standing. Steady, therapeutic pressure applied to reflex points helps the whole body let go.",
    suitedFor: "Long workdays, frequent standing, travel and everyday foot fatigue.",
    experience: "Concentrated foot massage with a steady, restful pace.",
    image: IMAGES.footMassage,
    video: "/rituals/v10.mp4",
    pricing: [
      { duration: "30 Minutes", price: "$40" },
      { duration: "45 Minutes", price: "$50" },
      { duration: "60 Minutes", price: "$60" },
    ],
  },
  {
    id: "head",
    number: "05",
    tag: "Scalp & Crown",
    name: "Head Massage",
    description:
      "A deeply calming head and scalp massage that melts away the tension carried in the crown, temples and neck. Pair it with a foot massage and receive a complimentary body treatment.",
    suitedFor: "Screen fatigue, tension headaches and stress held in the scalp, temples and neck.",
    experience: "Slow, rhythmic scalp work with quiet, restorative pauses.",
    image: IMAGES.headMassage,
    video: "/rituals/v7.mp4",
    pricing: [
      { duration: "30 Minutes", price: "$60" },
      { duration: "60 Minutes", price: "$80" },
    ],
  },
];

export const ADD_ONS = [
  { name: "Essential Oil", price: "$5" },
  { name: "Scalp Massage · 10 mins", price: "$15" },
  { name: "Scalp Massage · 15 mins", price: "$20" },
  { name: "Cupping", price: "$20" },
];

export const OFFERS = [
  {
    number: "01",
    tag: "Grand Opening",
    title: "First Month 50% Off",
    text: "Celebrate our opening — every service is half price during our first month. Call to confirm your session and lock in the grand opening rate.",
  },
  {
    number: "02",
    tag: "Signature Pairing",
    title: "Free Body Treatment",
    text: "Book a head massage and a foot massage together and receive a complimentary body treatment — our favourite way to experience the full Elite ritual.",
  },
  {
    number: "03",
    tag: "With Every Add-On",
    title: "Free Hot Stone",
    text: "Enhance any session with essential oil, scalp massage or cupping — every add-on includes a complimentary hot stone treatment.",
  },
];

export const TIME_SLOTS = [
  "9:30 AM", "10:00 AM", "11:00 AM", "12:00 PM", "1:00 PM", "2:00 PM",
  "3:00 PM", "4:00 PM", "5:00 PM", "6:00 PM", "7:00 PM", "8:00 PM", "9:00 PM",
];

export const TESTIMONIALS = [
  { initial: "A", name: "Local Guest", quote: "The space felt calm from the moment I walked in. Everything was clean, quiet and very comfortable." },
  { initial: "M", name: "Lakewood Guest", quote: "Calling to arrange my visit was simple, and the pricing was easy to understand. A very relaxing experience." },
  { initial: "J", name: "Returning Guest", quote: "I appreciated the quiet atmosphere and the fact that I never felt rushed before or after my session." },
  { initial: "R", name: "Lakewood Guest", quote: "A peaceful place to unwind after a long week. The room was tidy, warm and very private." },
  { initial: "S", name: "Local Guest", quote: "The foot massage was exactly the kind of quiet break I needed after several long days on my feet." },
  { initial: "L", name: "First-Time Guest", quote: "The environment was peaceful and thoughtfully arranged. It was easy to relax and enjoy the time." },
  { initial: "C", name: "Local Guest", quote: "I liked having several session lengths to choose from. The entire visit felt straightforward and comfortable." },
  { initial: "D", name: "Evening Guest", quote: "The warm, quiet room helped me switch off from a very busy day. I left feeling refreshed and rested." },
  { initial: "K", name: "Returning Guest", quote: "A clean and private setting with a welcoming feel. The later hours also made scheduling much easier." },
  { initial: "N", name: "Lakewood Guest", quote: "Everything felt calm and unhurried. I especially appreciated the simple service menu and clear prices." },
];

export const FAQS = [
  {
    q: "How early should I arrive?",
    a: "Arriving approximately 10 minutes early is recommended so you have time to settle in, discuss your preferences and begin your visit without feeling rushed.",
  },
  {
    q: "Can I get a massage if I have an injury?",
    a: "Please speak with an appropriate healthcare professional before receiving massage when you have a recent injury, ongoing pain, medical condition or recovery restrictions. Contact Elite SPA in advance and explain any relevant concerns so the visit can be discussed. Massage services are not a substitute for medical diagnosis or treatment.",
  },
  {
    q: "What is your cancellation policy?",
    a: "Please call Elite SPA directly for the current cancellation policy. When plans change, contacting the spa as early as possible helps make scheduling adjustments easier.",
  },
  {
    q: "Is there parking available?",
    a: "Parking conditions can change. Please call before your visit for the latest parking guidance near the 1399 Kipling Street location.",
  },
];

export const EXPERIENCE_STEPS = [
  {
    number: "01",
    title: "Calm Arrival",
    text: "Arrive a few minutes early, settle in and allow the pace of the day to soften before your session begins.",
  },
  {
    number: "02",
    title: "Private Space",
    text: "A quiet treatment environment supports comfort, discretion and uninterrupted time to rest.",
  },
  {
    number: "03",
    title: "Mindful Details",
    text: "Session length, pressure preferences and areas of focus can be discussed before getting comfortable.",
  },
  {
    number: "04",
    title: "Restful Finish",
    text: "Take a quiet moment after your session before returning to the rest of your day.",
  },
];
